import { IPlan } from "../../../../common/types";
import { PlanActionTypes } from "../models/planActions";
import { UPDATE_PLAN } from "../types";

export default (data: IPlan): PlanActionTypes => ({
    type: UPDATE_PLAN,
    payload: data,
});